import { ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/message-box/style/css';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, withModifiers as _withModifiers, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "settlement-detail-account"
};
const _hoisted_2 = {
  key: 0,
  class: "settlement-detail-audit"
};
const _hoisted_3 = {
  style: {
    "margin-right": "30px"
  }
};
const _hoisted_4 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_5 = {
  style: {
    "margin-left": "30px"
  }
};
const _hoisted_6 = {
  key: 1,
  class: "settlement-detail-account"
};
const _hoisted_7 = {
  key: 2,
  style: {
    "width": "50%"
  }
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  key: 0,
  style: {
    "width": "100%"
  }
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  key: 2
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  key: 1
};
const _hoisted_17 = {
  key: 0,
  style: {
    "float": "left",
    "margin": "0px 10px 5px 0px"
  }
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  key: 1
};
const _hoisted_20 = {
  style: {
    "float": "right"
  }
};
import { computed, getCurrentInstance, onBeforeMount, onMounted, reactive, ref, watch } from "vue";
import apis from "@/api";
import { ElMessage } from "element-plus";
import RecordUpload from "../components/Upload.vue";
import ContractComparison from "./ContractComparison.vue";
import AccessoryUpload from '@/components/MoreUpload';
import MonitorStatus from "../../AdvertLaunchMonitor/components/MonitorStatus.vue";
export default {
  __name: 'ContractSettlementDetail',
  props: {
    title: {
      type: String,
      default: '结算单明细',
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    contract: {
      type: Object
    },
    detail: {
      type: Object
    },
    isAudit: {
      type: Boolean,
      default: false
    },
    isAccount: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    actionName: {
      type: String,
      default: 'handleView'
    }
  },
  emits: ['update:visible', 'submit'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const {
      proxy
    } = getCurrentInstance();
    const headerStyle = ref({
      background: '#FAFAFA'
    });
    const tableRowClassName = ({
      row,
      rowIndex
    }) => {
      if (false === row.curingPriceEt) {
        return 'warning-row';
      }
      return '';
    };
    const deleteBynV = computed(() => {
      if (props.actionName === 'handleView') {
        return true;
      }
      return false;
    });
    const emits = __emit;
    const props = __props;
    const data = reactive({
      tableData: [],
      pagination: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      audit: {
        examineState: 0,
        examineOpinion: null,
        totalIncludingTax: 0
      },
      account: {
        courierNumber: '',
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      accountFiles: [],
      recordTableData: [],
      recordPagination: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      activeNames: ['record'],
      activeNames2: ['accessory'],
      activeNames3: ['account'],
      activeNames4: ['comparison'],
      uploadTitle: "上传扫描件",
      fileInfos: [],
      comparisonData: [],
      uploadFiles: [],
      accessoryTableData: [],
      accessoryPagination: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      comparisonPagination: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      }
    });
    const pricingUnitItem = [{
      value: 1,
      label: '/'
    }, {
      value: 2,
      label: '天'
    }, {
      value: 3,
      label: '周'
    }, {
      value: 4,
      label: '月'
    }, {
      value: 5,
      label: '季度'
    }, {
      value: 6,
      label: '年'
    }];
    const elLoading = ref(false);
    const recordUpload = ref();
    const showHandleAudit = ref(false);
    const showRecordTag = ref(true);
    const isRecordTag = ref(false);
    const uploadVisible = ref(false);
    const comparisonVisible = ref(false);
    const close = () => {
      showHandleAudit.value = false;
      data.audit = {
        examineState: 0,
        examineOpinion: null,
        totalIncludingTax: 0
      };
      emits('update:visible', false);
    };
    //结算单信息分页改变
    const handleSizeChange = val => {
      data.pagination.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      data.pagination.pageNo = val;
      loadData();
    };
    //归档信息分页改变
    const handleSizeChangeRecord = val => {
      data.recordPagination.pageSize = val;
      loadDataDetailedSettlementTag(props.detail);
    };
    const handleCurrentChangeRecord = val => {
      data.recordPagination.pageNo = val;
      loadDataDetailedSettlementTag(props.detail);
    };
    //比对信息分页改变
    const handleSizeChangeComparison = val => {
      data.comparisonPagination.pageSize = val;
      loadComparison(props.detail);
    };
    const handleCurrentChangeComparison = val => {
      data.comparisonPagination.pageNo = val;
      loadComparison(props.detail);
    };
    //附件信息分页改变
    const handleSizeChangeAccessory = val => {
      data.accessoryPagination.pageSize = val;
      loadDataDetailedSettlementAccessoryTag(props.detail);
    };
    const handleCurrentChangeAccessory = val => {
      data.accessoryPagination.pageNo = val;
      loadDataDetailedSettlementAccessoryTag(props.detail);
    };
    const handleSizeChangeAccount = val => {
      data.account.pageSize = val;
      loadAccountTag(props.detail);
    };
    const handleCurrentChangeAccount = val => {
      data.account.pageNo = val;
      loadAccountTag(props.detail);
    };
    const loadData = () => {
      const param = {
        detailedId: props.detail.id,
        ...data.pagination
      };
      elLoading.value = true;
      apis.getDetailedSettlementList(param).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.tableData = records;
          data.pagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
          records.forEach(item => {
            data.audit.totalIncludingTax = data.audit.totalIncludingTax + item.totalIncludingTax;
          });
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
      });
    };
    const handleComparison = () => {
      comparisonVisible.value = true;
    };
    const handleAudit = () => {
      if (!data.audit.examineOpinion) {
        ElMessage.error("请输入审核意见");
        return;
      }
      data.audit.totalIncludingTax = props.detail.currentSettlementAmount.toFixed(6);
      const param = {
        comparisonList: data.comparisonData,
        detailedInfo: {
          id: props.detail.id,
          ...data.audit
        }
      };
      apis.updateDetailedCById(param).then(res => {
        if (res.success) {
          //提交审核后 审核按钮 不可点击
          if (data.audit.examineState == '0') {
            showHandleAudit.value = true;
            showRecordTag.value = true;
          } else {
            emits('update:visible', false);
          }
          data.audit = {
            examineState: 0,
            examineOpinion: null,
            totalIncludingTax: 0
          };
          ElMessage.success('合同结算单审核成功');
          emits('update:visible', false);
          emits('submit');
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        emits('submit');
      });
    };
    const DetailedSettlementList = row => {
      const param = {
        detailedId: row.id
      };
      apis.getDetailedSettlementList(param).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.tableData = records;
          data.pagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
          records.forEach(item => {
            data.audit.totalIncludingTax = data.audit.totalIncludingTax + item.totalIncludingTax;
          });
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
      });
    };
    const downFile = row => {
      window.open(row.fileUrl);
    };
    const handlerFileChange = files => {
      data.uploadFiles = files;
    };
    const updateSettlementState = row => {
      console.info("归档：", row);
      apis.updateSettlementState({
        'id': row.id
      }).then(res => {
        if (res.success) {
          //  更新结算单状态为归档
          ElMessage.success("已归档");
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        emits('submit');
      });
    };
    const handleUpload = () => {
      uploadVisible.value = true;
    };
    const selectComparison = items => {
      for (let item of items) {
        const repeat = data.comparisonData.filter(e => e.id === item.id);
        if (repeat.length === 0) {
          data.comparisonData.push(item);
        }
      }
    };
    const handlerUploadSuccess = files => {
      uploadVisible.value = false;
      if (files && files.length > 0) {
        let uploadFiles = [];
        files.forEach(f => {
          const name = f.fileName.substring(0, f.fileName.lastIndexOf("."));
          const item = {
            fileId: f.id,
            name: name,
            fileName: f.fileName,
            fileUrl: f.relativeUrl,
            upTime: f.uploadTime,
            upUser: f.operator,
            fileType: f.fileType,
            serviceType: '2',
            detailSettlementId: props.detail.id
          };
          uploadFiles.push(item);
        });
        data.accountFiles = data.accountFiles.concat(uploadFiles);
      } else {
        ElMessage.error('请先上传附件!');
      }
    };
    const handleAccount = () => {
      if (!data.account.courierNumber) {
        ElMessage.error('请输入快递单号!');
        return;
      }
      const updateData = {
        detailedInfo: {
          id: props.detail.id,
          courierNumber: data.account.courierNumber
        },
        upTagList: data.accountFiles
      };
      apis.updateCourierNumber(updateData).then(res => {
        if (res.success) {
          emits('submit');
          emits('update:visible', false);
          ElMessage.success('提交成功!');
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const handleDeleteAccountTag = row => {
      ElMessageBox.confirm('确定要删除该附件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        data.accountFiles = data.accountFiles.filter(f => f.fileId !== row.fileId);
      });
    };
    const handleDeleteTag = row => {
      ElMessageBox.confirm('确定要删除该附件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apis.deleteDetailedSettlementTagById({
          'id': row.id
        }).then(res => {
          if (res.success) {
            ElMessage.success('删除扫描件成功');
            //加载扫描件
            loadDataDetailedSettlementTag(props.detail);
          } else {
            ElMessage.error(res.msg);
          }
        }).catch(err => {
          ElMessage.error(err);
        });
      });
    };
    const handleDeleteComparison = row => {
      ElMessageBox.confirm('确定要删除该附件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        data.comparisonData = data.comparisonData.filter(e => e.id !== row.id);
      });
    };
    const handleComparisonView = row => {
      window.open(row.fileUrl);
    };
    const saveCG = () => {
      if (!data.uploadFiles || data.uploadFiles.length == 0) {
        ElMessage.error('请先选取扫描件');
        return;
      }
      let formData = new FormData();
      data.uploadFiles.forEach(f => {
        formData.append('fileList', f);
      });
      formData.append('bucketName', 'outer-for-inner');
      apis.upload(formData).then(res => {
        console.log("upload-res: ", res);
        if (res && res.success) {
          const files = res.data;
          console.info("saveCG files", files);
          if (files && files.length > 0) {
            let uploadFiles = [];
            files.forEach(f => {
              const name = f.fileName.substring(0, f.fileName.lastIndexOf("."));
              const item = {
                fileId: f.id,
                name: name,
                fileName: f.fileName,
                fileUrl: f.relativeUrl,
                upTime: f.uploadTime,
                upUser: f.operator,
                fileType: f.fileType,
                detailSettlementId: props.detail.id
              };
              uploadFiles.push(item);
            });
            data.fileInfos = data.fileInfos.concat(uploadFiles);
            // 执行插入记录
            apis.saveBatchDetailedSettlementTagInfo(data.fileInfos).then(res => {
              if (res.success) {
                ElMessage.success('保存成功！');
                //加载扫描件
                // loadDataDetailedSettlementTag(props.detail)
                //关闭弹窗
                emits('update:visible', false);
              } else {
                ElMessage.error(res.msg);
              }
            }).catch(err => {
              ElMessage.error(err);
            }).finally(() => {});
          } else {
            ElMessage.error('请先上传扫描件!');
          }
        } else {
          ElMessage.error('扫描文件上传失败:' + res.msg);
        }
      }).catch(err => {
        console.log("err", err);
        ElMessage.error('扫描文件上传失败');
      }).finally(() => {
        data.uploadFiles = [];
        data.fileInfos = [];
        recordUpload.value.clearFile();
        loadDataDetailedSettlementTag(props.detail);
      });
    };
    const saveGD = () => {
      if (data.uploadFiles && data.uploadFiles.length > 0) {
        // 此次操作上传了扫描文件，直接上传文件至服务器并保存信息并修改归档状态

        let formData = new FormData();
        data.uploadFiles.forEach(f => {
          formData.append('fileList', f);
        });
        formData.append('bucketName', 'outer-for-inner');
        apis.upload(formData).then(res => {
          console.log("upload-res: ", res);
          if (res && res.success) {
            const files = res.data;
            console.info("files", files);
            if (files && files.length > 0) {
              let uploadFiles = [];
              files.forEach(f => {
                const name = f.fileName.substring(0, f.fileName.lastIndexOf("."));
                const item = {
                  fileId: f.id,
                  name: name,
                  fileName: f.fileName,
                  fileUrl: f.relativeUrl,
                  upTime: f.uploadTime,
                  upUser: f.operator,
                  fileType: f.fileType,
                  detailSettlementId: props.detail.id
                };
                uploadFiles.push(item);
              });
              data.fileInfos = data.fileInfos.concat(uploadFiles);
              // 执行插入记录
              apis.saveBatchDetailedSettlementTagInfo(data.fileInfos).then(res => {
                if (res.success) {
                  //根据save type 修改结算单状态为已归档
                  updateSettlementState(props.detail);
                  //加载扫描件
                  // loadDataDetailedSettlementTag(props.detail)
                  //关闭弹窗
                  emits('update:visible', false);
                } else {
                  ElMessage.error(res.msg);
                }
              }).catch(err => {
                ElMessage.error(err);
              }).finally(() => {});
            } else {
              ElMessage.error('请先上传扫描件!');
            }
          } else {
            ElMessage.error('扫描文件上传失败:' + res.msg);
          }
        }).catch(err => {
          console.log("err", err);
          ElMessage.error('扫描文件上传失败');
        }).finally(() => {
          data.uploadFiles = [];
          data.fileInfos = [];
          recordUpload.value.clearFile();
          loadDataDetailedSettlementTag(props.detail);
        });
      } else {
        //此次操作未上传扫描件

        if (!data.recordTableData || data.recordTableData.length == 0) {
          //没有草稿数据
          ElMessage.error('无扫描件数据，请先上传扫描件!');
          return;
        } else {
          //有草稿数据直接更新归档状态

          //根据save type 修改结算单状态为已归档
          updateSettlementState(props.detail);
          //加载扫描件
          // loadDataDetailedSettlementTag(props.detail)
          //关闭弹窗
          data.uploadFiles = [];
          data.fileInfos = [];
          recordUpload.value.clearFile();
          emits('update:visible', false);
        }
      }
    };
    const loadDataDetailedSettlementTag = row => {
      const param = {
        // ...data.recordPagination,
        total: data.recordPagination.totalSize,
        size: data.recordPagination.pageSize,
        current: data.recordPagination.pageNo,
        detailSettlementId: row.id
      };
      apis.queryDetailedSettlementTagByPage(param).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.recordTableData = records;
          data.recordPagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {});
    };
    const loadAccountTag = row => {
      const param = {
        total: data.account.totalSize,
        size: data.account.pageSize,
        current: data.account.pageNo,
        detailSettlementId: row.id,
        serviceType: '2'
      };
      apis.queryDetailedSettlementAccessoryTagByPage(param).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.accountFiles = records;
          data.account.totalSize = total;
          data.account.pageSize = size;
          data.account.pageNo = current;
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      });
    };
    const loadComparison = row => {
      const param = {
        total: data.comparisonPagination.totalSize,
        size: data.comparisonPagination.pageSize,
        current: data.comparisonPagination.pageNo,
        detailId: row.id
      };
      if (props.isAudit) {
        param.total = 200;
      }
      apis.pageComparison(param).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.comparisonData = records;
          data.comparisonPagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
          data.comparisonData = [];
        }
      }).catch(err => {
        ElMessage.error(err);
        data.comparisonData = [];
      }).finally(() => {});
    };
    const loadDataDetailedSettlementAccessoryTag = row => {
      const param = {
        // ...data.accessoryPagination,
        total: data.accessoryPagination.totalSize,
        size: data.accessoryPagination.pageSize,
        current: data.accessoryPagination.pageNo,
        detailSettlementId: row.id,
        serviceType: '1'
      };
      apis.queryDetailedSettlementAccessoryTagByPage(param).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.accessoryTableData = records;
          data.accessoryPagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {});
    };
    const getSumAmount = () => {
      const sums = [];
      sums[0] = '合计';
      let sumExcluding = 0;
      let sumtIncluding = 0;
      data.tableData.forEach(column => {
        sumExcluding = sumExcluding + column.totalExcludingTax * 100;
        sumtIncluding = sumtIncluding + column.totalIncludingTax * 100;
      });
      sums[9] = '本次结算金额';
      sums[10] = Number(props.detail.currentSettlementAmount.toFixed(6));
      sums[11] = Number((sumExcluding / 100).toFixed(6));
      sums[12] = Number((sumtIncluding / 100).toFixed(6));
      return sums;
    };
    watch(() => props.actionName, (newvalue, oldvalue) => {
      if (newvalue === 'handleAudit') {
        showRecordTag.value = false;
      } else {
        showRecordTag.value = true;
      }
      if (newvalue === 'handleRecord') {
        isRecordTag.value = true;
      } else {
        isRecordTag.value = false;
      }
    }, {
      deep: false,
      immediate: true
    });
    __expose({
      DetailedSettlementList,
      loadDataDetailedSettlementTag,
      loadDataDetailedSettlementAccessoryTag,
      loadAccountTag,
      loadComparison
    });
    return (_ctx, _cache) => {
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_collapse_item = _resolveComponent("el-collapse-item");
      const _component_el_collapse = _resolveComponent("el-collapse");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: __props.title,
        "model-value": __props.visible,
        onClose: close,
        "close-on-press-escape": false,
        "destroy-on-close": true,
        width: "100%",
        fullscreen: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_descriptions, {
          title: "基本信息",
          column: 3,
          style: {
            "width": "70%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
            label: "合同编号："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.contract.contractCode), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "合同名称："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.contract.contractName), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "供应商："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.contract.supplier), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "结算单标题："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.detail.statementName), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "创建时间："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.detail.createDate), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "结算比例："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.detail.settlementRate ? __props.detail.settlementRate : '100') + "%", 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "结算比例说明："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.detail.settlementRateDesc), 1)]),
            _: 1
          })]),
          _: 1
        })]), __props.isAudit ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: handleComparison,
          disabled: showHandleAudit.value
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("选择比对报告", -1)]))]),
          _: 1
        }, 8, ["disabled"])]), _createElementVNode("div", null, [_createVNode(_component_el_input, {
          modelValue: data.audit.examineOpinion,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.audit.examineOpinion = $event),
          placeholder: "请输入审核意见"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_radio_group, {
          modelValue: data.audit.examineState,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.audit.examineState = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: 0
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("通过", -1)]))]),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: 1
          }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("不通过", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: handleAudit,
          disabled: showHandleAudit.value
        }, {
          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode("提交审核意见", -1)]))]),
          _: 1
        }, 8, ["disabled"])])])) : _createCommentVNode("", true), __props.isAccount ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_form, null, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "快递单号："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.account.courierNumber,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.account.courierNumber = $event),
              placeholder: "请输入快递单号",
              style: {
                "width": "400px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })])) : _createCommentVNode("", true), __props.detail.examineState === 4 || __props.detail.examineState === 0 || __props.detail.examineState === 9 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_descriptions, null, {
          default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
            label: "快递单号："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.detail.courierNumber), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "填写时间："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.detail.courierDate), 1)]),
            _: 1
          })]),
          _: 1
        })])) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("div", null, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: data.tableData,
          style: {
            "width": "100%"
          },
          "header-cell-style": headerStyle.value,
          height: "600",
          "row-class-name": tableRowClassName,
          border: "",
          "show-summary": "",
          "summary-method": getSumAmount
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "ranking",
            label: "序号"
          }), _createVNode(_component_el_table_column, {
            prop: "productCategory",
            label: "产品大类/类别",
            "min-width": "100"
          }), _createVNode(_component_el_table_column, {
            prop: "projectContent",
            label: "产品小类/项目内容",
            "min-width": "300"
          }), _createVNode(_component_el_table_column, {
            prop: "standardSpecifications",
            label: "标准规格",
            "min-width": "300"
          }), _createVNode(_component_el_table_column, {
            prop: "remarks",
            label: "备注",
            "min-width": "100"
          }), _createVNode(_component_el_table_column, {
            prop: "unit",
            label: "报价单位"
          }), _createVNode(_component_el_table_column, {
            prop: "unitPriceExcludingTax",
            label: "不含税单价/元"
          }), _createVNode(_component_el_table_column, {
            prop: "vatRate",
            label: "增值税率"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.vatRate) + "%", 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "unitPriceIncludingTax",
            label: "含税单价/元"
          }), _createVNode(_component_el_table_column, {
            prop: "settlementQuantity",
            label: "结算数量"
          }), _createVNode(_component_el_table_column, {
            label: "计价维度"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              prop: "pricingQuantity",
              label: "时长"
            }), _createVNode(_component_el_table_column, {
              label: "单位",
              "min-width": "85"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_select, {
                modelValue: scope.row.pricingUnit,
                "onUpdate:modelValue": $event => scope.row.pricingUnit = $event,
                placeholder: "",
                size: "small",
                disabled: "true"
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(pricingUnitItem, item => {
                  return _createVNode(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "totalExcludingTax",
            label: "不含税合计（元）"
          }), _createVNode(_component_el_table_column, {
            prop: "totalIncludingTax",
            label: "含税合计（元）",
            "min-width": "100"
          })]),
          _: 1
        }, 8, ["data", "header-cell-style"])), [[_directive_loading, elLoading.value]])]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange,
          "page-sizes": [10, 20, 50, 100, 200, 500],
          "page-size": data.pagination.pageSize,
          total: data.pagination.totalSize,
          currentPage: data.pagination.pageNo,
          "onUpdate:currentPage": _cache[3] || (_cache[3] = $event => data.pagination.pageNo = $event),
          layout: "total, prev, pager, next, sizes, jumper"
        }, null, 8, ["page-size", "total", "currentPage"])]), _createVNode(_component_el_collapse, {
          modelValue: data.activeNames2,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => data.activeNames2 = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_collapse_item, {
            title: "结算单附件",
            name: "accessory"
          }, {
            default: _withCtx(() => [data.accessoryTableData && data.accessoryTableData.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", null, [_createVNode(_component_el_table, {
              data: data.accessoryTableData,
              style: {
                "width": "100%"
              },
              "header-cell-style": headerStyle.value
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                prop: "name",
                label: "文件名"
              }), _createVNode(_component_el_table_column, {
                prop: "upTime",
                label: "上传时间"
              }), _createVNode(_component_el_table_column, {
                prop: "upUser",
                label: "上传人"
              }), _createVNode(_component_el_table_column, {
                label: "操作",
                width: "150"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_button, {
                  link: "",
                  size: "small",
                  type: "primary",
                  onClick: $event => downFile(scope.row)
                }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode("下载", -1)]))]),
                  _: 1
                }, 8, ["onClick"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data", "header-cell-style"])]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
              onSizeChange: handleSizeChangeAccessory,
              onCurrentChange: handleCurrentChangeAccessory,
              "page-sizes": [10, 20, 50, 100, 200],
              "page-size": data.accessoryPagination.pageSize,
              total: data.accessoryPagination.totalSize,
              currentPage: data.accessoryPagination.pageNo,
              "onUpdate:currentPage": _cache[4] || (_cache[4] = $event => data.accessoryPagination.pageNo = $event),
              layout: "total,prev, pager, next, sizes, jumper"
            }, null, 8, ["page-size", "total", "currentPage"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_empty, {
              description: "未上传附件信息",
              "image-size": "50"
            })]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), __props.detail.examineState === 4 || __props.detail.examineState === 0 || __props.detail.examineState === 9 ? (_openBlock(), _createBlock(_component_el_collapse, {
          key: 0,
          modelValue: data.activeNames3,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => data.activeNames3 = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_collapse_item, {
            title: "报账单附件",
            name: "account"
          }, {
            default: _withCtx(() => [__props.isAccount ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_button, {
              type: "primary",
              style: {
                "float": "right",
                "margin-left": "30px"
              },
              onClick: handleAccount
            }, {
              default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode("提交报账", -1)]))]),
              _: 1
            }), _createVNode(_component_el_button, {
              style: {
                "float": "right"
              },
              type: "primary",
              onClick: _withModifiers(handleUpload, ["stop"])
            }, {
              default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode("上传扫描件", -1)]))]),
              _: 1
            })])) : _createCommentVNode("", true), data.accountFiles && data.accountFiles.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", null, [_createVNode(_component_el_table, {
              data: data.accountFiles,
              style: {
                "width": "100%"
              },
              "header-cell-style": headerStyle.value
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                prop: "name",
                label: "文件名"
              }), _createVNode(_component_el_table_column, {
                prop: "upTime",
                label: "上传时间"
              }), _createVNode(_component_el_table_column, {
                prop: "upUser",
                label: "上传人"
              }), _createVNode(_component_el_table_column, {
                label: "操作",
                width: "150"
              }, {
                default: _withCtx(scope => [!__props.isAccount ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  link: "",
                  size: "small",
                  type: "primary",
                  onClick: $event => downFile(scope.row)
                }, {
                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("下载", -1)]))]),
                  _: 1
                }, 8, ["onClick"])) : _createCommentVNode("", true), __props.isAccount ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  link: "",
                  size: "small",
                  type: "primary",
                  onClick: $event => handleDeleteAccountTag(scope.row)
                }, {
                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode("删除", -1)]))]),
                  _: 1
                }, 8, ["onClick"])) : _createCommentVNode("", true)]),
                _: 1
              })]),
              _: 1
            }, 8, ["data", "header-cell-style"])]), !__props.isAccount ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_el_pagination, {
              onSizeChange: handleSizeChangeAccount,
              onCurrentChange: handleCurrentChangeAccount,
              "page-sizes": [10, 20, 50, 100, 200],
              "page-size": data.account.pageSize,
              total: data.account.totalSize,
              currentPage: data.account.pageNo,
              "onUpdate:currentPage": _cache[6] || (_cache[6] = $event => data.account.pageNo = $event),
              layout: "total,prev, pager, next, sizes, jumper"
            }, null, 8, ["page-size", "total", "currentPage"])])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_el_empty, {
              description: "未上传附件信息",
              "image-size": "50"
            })]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_el_collapse, {
          modelValue: data.activeNames4,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => data.activeNames4 = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_collapse_item, {
            title: "比对报告",
            name: "comparison"
          }, {
            default: _withCtx(() => [data.comparisonData && data.comparisonData.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", null, [_createVNode(_component_el_table, {
              data: data.comparisonData,
              style: {
                "width": "100%"
              },
              "header-cell-style": headerStyle.value
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                prop: "taskName",
                label: "任务名称"
              }), _createVNode(_component_el_table_column, {
                prop: "opCompany",
                label: "执行公司"
              }), _createVNode(_component_el_table_column, {
                prop: "opName",
                label: "执行人"
              }), _createVNode(_component_el_table_column, {
                prop: "fileName",
                label: "附件名称"
              }), _createVNode(_component_el_table_column, {
                prop: "monitorState",
                label: "监测状态"
              }, {
                default: _withCtx(scope => [_createVNode(MonitorStatus, {
                  "monitor-state": scope.row.monitorState
                }, null, 8, ["monitor-state"])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "操作",
                width: "150"
              }, {
                default: _withCtx(scope => [_createElementVNode("div", null, [_createVNode(_component_el_button, {
                  link: "",
                  type: "primary",
                  size: "small",
                  onClick: $event => handleComparisonView(scope.row)
                }, {
                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode("查看附件", -1)]))]),
                  _: 1
                }, 8, ["onClick"])]), _createElementVNode("div", null, [__props.isAudit ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  link: "",
                  size: "small",
                  type: "primary",
                  onClick: $event => handleDeleteComparison(scope.row),
                  disabled: deleteBynV.value
                }, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode("删除", -1)]))]),
                  _: 1
                }, 8, ["onClick", "disabled"])) : _createCommentVNode("", true)])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data", "header-cell-style"])]), !__props.isAudit ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_el_pagination, {
              onSizeChange: handleSizeChangeComparison,
              onCurrentChange: handleCurrentChangeComparison,
              "page-sizes": [10, 20, 50, 100, 200],
              "page-size": data.comparisonPagination.pageSize,
              total: data.comparisonPagination.totalSize,
              currentPage: data.comparisonPagination.pageNo,
              "onUpdate:currentPage": _cache[8] || (_cache[8] = $event => data.comparisonPagination.pageNo = $event),
              layout: "total,prev, pager, next, sizes, jumper"
            }, null, 8, ["page-size", "total", "currentPage"])])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_el_empty, {
              description: "无比对报告信息",
              "image-size": "50"
            })]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), __props.isAdmin && showRecordTag.value ? (_openBlock(), _createBlock(_component_el_collapse, {
          key: 1,
          modelValue: data.activeNames,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => data.activeNames = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_collapse_item, {
            title: "归档信息",
            name: "record"
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [__props.isAudit || isRecordTag.value ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(RecordUpload, {
              "btn-text": data.uploadTitle,
              multiple: true,
              "vaild-img-type": false,
              ref_key: "recordUpload",
              ref: recordUpload,
              onFileChange: handlerFileChange
            }, null, 8, ["btn-text"])])) : _createCommentVNode("", true)]), data.recordTableData && data.recordTableData.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", null, [_createVNode(_component_el_table, {
              data: data.recordTableData,
              style: {
                "width": "100%"
              },
              "header-cell-style": headerStyle.value
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                prop: "name",
                label: "文件名"
              }), _createVNode(_component_el_table_column, {
                prop: "upTime",
                label: "上传时间"
              }), _createVNode(_component_el_table_column, {
                prop: "upUser",
                label: "上传人"
              }), _createVNode(_component_el_table_column, {
                label: "操作",
                width: "150"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_button, {
                  link: "",
                  size: "small",
                  type: "primary",
                  onClick: $event => downFile(scope.row)
                }, {
                  default: _withCtx(() => [...(_cache[27] || (_cache[27] = [_createTextVNode("下载", -1)]))]),
                  _: 1
                }, 8, ["onClick"]), _createVNode(_component_el_button, {
                  link: "",
                  size: "small",
                  type: "primary",
                  onClick: $event => handleDeleteTag(scope.row),
                  disabled: deleteBynV.value
                }, {
                  default: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createTextVNode("删除 ", -1)]))]),
                  _: 1
                }, 8, ["onClick", "disabled"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data", "header-cell-style"])]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
              onSizeChange: handleSizeChangeRecord,
              onCurrentChange: handleCurrentChangeRecord,
              "page-sizes": [10, 20, 50, 100, 200],
              "page-size": data.recordPagination.pageSize,
              total: data.recordPagination.totalSize,
              currentPage: data.recordPagination.pageNo,
              "onUpdate:currentPage": _cache[10] || (_cache[10] = $event => data.recordPagination.pageNo = $event),
              layout: "total,prev, pager, next, sizes, jumper"
            }, null, 8, ["page-size", "total", "currentPage"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_el_empty, {
              description: "无归档文件信息",
              "image-size": "50"
            })])), _createElementVNode("div", _hoisted_20, [__props.isAudit || isRecordTag.value ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _cache[11] || (_cache[11] = $event => saveCG())
            }, {
              default: _withCtx(() => [...(_cache[29] || (_cache[29] = [_createTextVNode("保存草稿", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true), __props.isAudit || isRecordTag.value ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              onClick: _cache[12] || (_cache[12] = $event => saveGD())
            }, {
              default: _withCtx(() => [...(_cache[30] || (_cache[30] = [_createTextVNode("提交归档", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true)])]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])) : _createCommentVNode("", true)]), _createVNode(_unref(AccessoryUpload), {
          visible: uploadVisible.value,
          "onUpdate:visible": _cache[14] || (_cache[14] = $event => uploadVisible.value = $event),
          multiple: true,
          onUploadSuccess: handlerUploadSuccess
        }, null, 8, ["visible"]), _createVNode(ContractComparison, {
          visible: comparisonVisible.value,
          "onUpdate:visible": _cache[15] || (_cache[15] = $event => comparisonVisible.value = $event),
          multiple: true,
          "contract-code": __props.contract.contractCode,
          onSelect: selectComparison
        }, null, 8, ["visible", "contract-code"])]),
        _: 1
      }, 8, ["title", "model-value"]);
    };
  }
};